import Dialog from '@material-ui/core/Dialog';
import { rem } from 'polished';
import styled from 'styled-components';
import { black, blue, white } from '../../common/colors';

export const StyledLtpDialog = styled(Dialog)`
  .MuiDialog-paper {
    max-width: ${rem(560)};
    width: 100%;
    border-radius: 0;
  }
`;

export const StyledLtpContent = styled.div`
  background-color: ${white};
  color: ${black};
  padding: ${rem(24)} ${rem(20)} ${rem(28)};
  line-height: 1.5;
  font-size: ${rem(16)};

  h2 {
    margin: 0 0 ${rem(16)} 0;
    font-size: ${rem(22)};
    font-weight: 600;
    line-height: 1.3;
  }

  p {
    margin: 0 0 ${rem(20)} 0;
  }

  a {
    color: ${blue};
    text-decoration: underline;

    :hover,
    :focus {
      text-decoration: none;
    }
  }
`;

export const StyledLtpActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: ${rem(4)};
`;
